import { Injectable } from '@angular/core';

import { NgRedux } from '@angular-redux/store';

import { Observable } from 'rxjs';

import { RouteTripItem } from '../../schedule.model';
import { SchedulePartialStoreState } from '../schedule.reducer';
import { RouteTripActions } from './route-trip.actions';
import * as RouteTripSelector from './route-trip.selectors';

@Injectable()
export class RouteTripFacade {
    tripStops$: Observable<RouteTripItem[]> = this.store.select(RouteTripSelector.getTrip);
    loading$: Observable<boolean> = this.store.select(RouteTripSelector.getLoading);

    constructor(private store: NgRedux<SchedulePartialStoreState>, private actions: RouteTripActions) { }

    fetchRouteTrip(tripId: number) {
        this.store.dispatch(this.actions.fetchRouteTrip(tripId));
    }
}
